<div class="header" style="background-image: url(assets/images/UH-Bground.jpg); background-position: bottom center; background-size: contain; background-repeat: no-repeat;">
  <div class="row">
    <div class="col text-center">
      <img src="assets/images/UH-header.jpg" style="max-height: 500px!important; visibility: hidden;" class="header-img" alt="Universal Health">
    </div>
  </div>
  <a name="top"></a>
  <div class="row header-title-bg" style="max-height: 50px;">
    <div class="col">
      <nav class="navbar navbar-expand-lg navbar-white container-fluid text-center" style="padding:0px; z-index: 10000;">
        <!-- <a class="navbar-brand" [routerLink]="['']">
          <h1 class="header-title">Universal Health</h1>
          <h2 class="header-sub-title">Restore + Sustain + Advance</h2>
        </a> -->
        <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="fas fa-bars"></span> Menu
        </button> -->

        <div class="" id="navbarSupportedContent" style="margin: 0 auto;">
          <!-- <ul class="navbar-nav mr-auto">
          </ul> -->
          <!-- ml-auto -->
          <ul class="navbar-nav" style="margin: 0 auto;">
            <li class="nav-item" *ngIf="app.config!=null && app.config.showHomeMenu">
              <a class="nav-link" [href]="app.config.mainWebsiteUrl" tabindex="-1" aria-disabled="true">
                <i class="fas fa-home d-sm-none"></i>
                <span class="d-sm-block d-none">Home</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['select-consultation']" tabindex="-1" aria-disabled="true">
                <i class="fas fa-book d-sm-none"></i>
                <span class="d-sm-block d-none">Book an Appointment</span>
              </a>
            </li>
            <li class="nav-item" >
              <a class="nav-link" [routerLink]="['gift-vouchers']" tabindex="-1" aria-disabled="true">
                <i class="fas fa-gift d-sm-none"></i>
                <span class="d-sm-block d-none">Buy a Gift Voucher</span>                
              </a>
            </li>
            <li class="nav-item" >
              <a class="nav-link" (click)="gotoCart()" tabindex="-1" aria-disabled="true">
                <table style="border-collapse: collapse; border:none;">
                  <tr>
                    <td style="border-collapse: collapse; border:none;"><i class="fas fa-shopping-cart"></i></td>
                    <td style="border-collapse: collapse; border:none;"><span *ngIf="app.basketItems!=null && app.basketItems.length>0" class="badge badge-danger cart-counter">{{app.basketItems.length}}</span></td>
                  </tr>
                </table>
              </a>
            </li>
            <li class="nav-item d-sm-block d-none" *ngIf="app.customer==null">
              <a class="nav-link" [routerLink]="['customer/login']" tabindex="-1" aria-disabled="true">Login</a>
            </li>
            <li class="nav-item d-sm-block d-none" *ngIf="app.customer==null">
              <a class="nav-link" [routerLink]="['customer/register']" tabindex="-1" aria-disabled="true">Register</a>
            </li>
            <li class="nav-item dropdown d-sm-none" *ngIf="app.customer==null">
              <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-user"></i>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" [routerLink]="['customer/login']">Login</a>
                <a class="dropdown-item" [routerLink]="['customer/register']">Register</a>
              </div>
            </li>
            <li class="nav-item dropdown" *ngIf="app.customer!=null">
              <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-user d-sm-none"></i>
                <span class="d-sm-block d-none">Welcome {{app.customer.firstName}}&nbsp;<i class="fas fa-caret-down"></i></span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" *ngIf="app.config.showProfileLink" [routerLink]="['customer/profile']">Profile</a>
                <a class="dropdown-item" [routerLink]="['customer/change-password']" >Change Password</a>
                <a class="dropdown-item" *ngIf="app.config.showIncomingAppointments" [routerLink]="['customer/future-bookings']" >Future Bookings</a>
                <a class="dropdown-item" *ngIf="app.config.showTransactionHistory" [routerLink]="['customer/transaction-history']" >Transaction History</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" [routerLink]="['customer/logout']">Logout</a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</div>
